var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('div', {
    staticClass: "load-overlay"
  }, [_c('div', {
    staticClass: "load"
  })]) : _vm._e(), _c('router-view')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }